import { createSafeContext } from '@/util/context';

import type { UnleashContextValue } from '../type';

const UnleashContext = createSafeContext<UnleashContextValue>();

export default UnleashContext;
